import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { Check, MailIcon, UserCheck, UserX, X } from 'lucide-react'
import i18n from 'i18next'
import { lazy } from 'react'
const IssuesFiltersDateRangePicker = lazy(
  () =>
    import(
      '@/routes/projectStages/issues/view/filters/issuesFiltersDateRangePicker/IssuesFiltersDateRangePicker.tsx'
    ),
)

export const deadlineProperty: PopoverProperty = {
  label: 'component',
  value: 'deadline',
  component: <IssuesFiltersDateRangePicker nested filterKey={'deadline'} />,
}

export const updatedAtProperty: PopoverProperty = {
  label: 'component',
  value: 'updatedAt',
  component: <IssuesFiltersDateRangePicker nested filterKey={'updatedAt'} />,
}

export const createdAtProperty: PopoverProperty = {
  label: 'component',
  value: 'createdAt',
  component: <IssuesFiltersDateRangePicker nested filterKey={'createdAt'} />,
}

export const recipientsProperty: PopoverProperty = {
  label: i18n.t(`project.issues.dialog.recipient`),
  value: 'recipients',
  icon: <UserX className={`size-4`} />,
  parent: 'recipients'
}

export const creatorsProperty: PopoverProperty = {
  label: i18n.t(`project.issues.creator`),
  value: 'creators',
  icon: <UserCheck className={`size-4`} />,
  parent: 'creators'
}

export const clearFiltersProperty: PopoverProperty = {
  label: i18n.t(`project.issues.clearFilters`),
  value: `clearFilters`,
  icon: <X className={`size-4`} />,
}

export const notFoundProperty = {
  label: i18n.t('error.notFound'),
  value: '',
  icon: <X />,
}
export const mailInviteProperty: PopoverProperty = {
  label: 'Zaproś przez email',
  value: 'externalInvite',
  icon: <MailIcon className={`size-4`} />,
}

export const selectAllProperty: PopoverProperty = {
  label: i18n.t('common.selectAll'),
  value: 'select-all',
  icon: <Check className={`size-4`} />,
}
